// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__y_tyz","list":"styles_list__UHHPa"};